import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SignatureType } from 'src/app/enum/signature-type';

const CONTROLLER = 'accessToken';

// The signing link loses its accessKey on the first redirect, so a reload of the signing pages
// reads it back from the tab.
const STORAGE_KEY = 'signer.signatureAccess';

@Injectable({
  providedIn: 'root'
})
export class AccessTokenService {


  tokenAccess = { accessToken: '', accessKey: '', batch: false };

  signatureType: SignatureType;

  constructor(private http: HttpClient) {
  }

  public generateCode(): Observable<any> {
    return this.http.post(`${CONTROLLER}/generateCode`,
      { accessKey: this.tokenAccess.accessKey });
  }

  public resendCode(): Observable<any> {
    return this.http.put(CONTROLLER, { accessKey: this.tokenAccess.accessKey })
      .pipe(
        catchError(this.handleError));
  }

  public validateCode(data: any): Observable<any> {
    this.tokenAccess.accessToken = data.accessToken;
    return this.http.post(CONTROLLER + '/', data);
  }

  public setAccessKey(accessKey: string) {
    if (accessKey !== this.tokenAccess.accessKey) {
      this.tokenAccess.accessToken = '';
    }

    this.tokenAccess.accessKey = accessKey;
    this.persist();
  }

  public setAccessToken(accessToken: string) {
    this.tokenAccess.accessToken = accessToken;
    this.persist();
  }

  public setBatch(batch: boolean) {
    this.tokenAccess.batch = batch;
    this.persist();
  }

  public setSignatureType(signatureType: SignatureType) {
    this.signatureType = signatureType;
    this.persist();
  }

  public getAccessKey() {
    return this.tokenAccess.accessKey;
  }

  public getAccessToken() {
    return this.tokenAccess.accessToken;
  }

  public getBatch() {
    return this.tokenAccess.batch;
  }

  public getSignatureType() {
    return this.signatureType;
  }

  // Restored only on demand: the interceptor sends the accessKey on every request, including
  // pages outside the signing flow.
  public restore(): boolean {
    try {
      const stored = JSON.parse(sessionStorage.getItem(STORAGE_KEY));
      if (!stored?.accessKey) {
        return false;
      }

      this.tokenAccess = { accessKey: stored.accessKey, accessToken: stored.accessToken ?? '', batch: !!stored.batch };
      this.signatureType = stored.signatureType ?? null;
      return true;
    } catch {
      return false;
    }
  }

  public stepValidation(route) {
  }

  private persist() {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ ...this.tokenAccess, signatureType: this.signatureType }));
    } catch { }
  }

  private handleError(errorResponse: HttpErrorResponse) {
    console.log(errorResponse.statusText);
    return throwError(errorResponse.error || 'Server error');
  }
}
